import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Button, CardMedia } from "@mui/material";
import RejectReasonModal from "../../Modals/rejectReason";
import SearchBar from "../../components/SearchBar";
import OffersAcceptedList from "../../features/manageOffers/offersAcceptedList";
import OffersApprovedList from "../../features/manageOffers/offersApprovedList";
import OffersCompletedList from "../../features/manageOffers/offersCompletedList";
import OffersInprogressList from "../../features/manageOffers/offersInprogressList";
import OffersPendingList from "../../features/manageOffers/offersPendingList";
import OffersRejectedList from "../../features/manageOffers/offersRejectedList";
import OffersScheduledList from "../../features/manageOffers/offersScheduledList";
import {
  useLazyGetCustomerByIdQuery,
  useUpdateCustomerMutation,
} from "../../services/customer";
import { showError, showToast, showWarning } from "../../constants/toasts";
import { Customer, Offers } from "../../types/General";
import moment from "moment";
import CompanyDocumentation from "../../features/manageCustomers/CustomerDocs";
import {
  useAcceptRejectOfferMutation,
  useLazyGetOffersQuery,
} from "../../services/main";
import { isValidInput } from "../../utils/validations";
import TeamDocumentModal from "../../Modals/teamDocument";
import { OFFER_STATUS, USER_STATUS } from "../../utils/enums";
import RejectedReasonDetailModal from "../../Modals/rejectedReasonDetail";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import ViewDocModal from "../../Modals/viewDocModal";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MaintenanceTeamDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [getCustomerById] = useLazyGetCustomerByIdQuery();
  const [getOffersMethod] = useLazyGetOffersQuery();
  const [updateStatus] = useAcceptRejectOfferMutation();

  const [updateCustomer] = useUpdateCustomerMutation();
  const [teamDetail, setTeamDetail] = useState<Customer | null>(null);
  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectionRsn, setRejectionRsn] = useState("");
  const [type, setType] = React.useState("");
  const [commission, setCommission] = useState("");
  const [openDocView, setOpenDocView] = useState(false);
  const [pdfFile, setPdfFile] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [selectedQuatation, setSelectedQuatation] = useState("");
  const [open1, setOpen1] = useState(false);
  const [docOpen, setDocOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<Offers[]>([]);
  const [count, setCount] = useState(0);
  const [reject, setReject] = useState(false);
  const [docViewImage, setDocViewImage] = useState("");
  const [selectedReasonType, setSelectedReasonType] = useState<string>("");

  const [valueTabs, setValueTabs] = useState(0);
  const [valueTabs2, setValueTabs2] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);

  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [open, setOpen] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getCustomerById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setTeamDetail(response?.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (status: number) => {
    if (selectedId) {
      if (status === OFFER_STATUS.REJECTED && !rejectionRsn) {
        showWarning("Please add rejection reason");
        return;
      }

      if (status === OFFER_STATUS.ACCEPTED && !commission) {
        showWarning("Please add commission");
        return;
      }
      if (status === OFFER_STATUS.ACCEPTED && !pdfFile) {
        showWarning("Please add admin quotation");
        return;
      }

      const body = {
        offerId: selectedId,
        status: status,
        ...(status === OFFER_STATUS.REJECTED
          ? { rejectReason: rejectionRsn || "" }
          : {}),
        ...(status === OFFER_STATUS.ACCEPTED
          ? { adminCommission: Number(commission) || 0 }
          : {}),
        ...(status === OFFER_STATUS.ACCEPTED
          ? { adminQuoatation: pdfFile || "" }
          : {}),
      };

      try {
        const response = await updateStatus(body).unwrap();
        if (response?.statusCode === 200) {
          if (status === OFFER_STATUS.REJECTED) {
            showToast("Offer rejected successfully");
          } else {
            showToast("Offer accepted successfully");
          }
          setOpen1(false);
          setOpen(false);
          if (id) {
            getData(id);
          }
        } else {
          showError("Please try again");
        }
      } catch (error: any) {
        console.log(error, "errror");
        showError(error?.data?.message || "");
      }
    }
  };

  const handleChangeStatus = async (status: number) => {
    try {
      const body =
        status == 1
          ? {
              status,
              userId: id,
            }
          : {
              status,
              userId: id,
              rejectReason: rejectionRsn,
              rejectType: Number(selectedReasonType),
            };

      const response = await updateCustomer({ ...body }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          status === USER_STATUS.APPROVED
            ? "Team approved successfully"
            : "Team rejected successfully"
        );

        navigate(-1);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const getOffers = async (id: string) => {
    setLoading(true);
    try {
      const response = await getOffersMethod({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        userId: id,
        status: valueTabs1 + 1,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setLoading(false);
        setRows(response?.data?.data || []);
        setCount(response?.data?.count || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getData(id);
      getOffers(id);
    }
  }, [valueTabs1, debouncedSearchTerm]);
  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>Maintenance Team Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-maintenance-team")}>
              Manage Maintenance Team
            </span>{" "}
            - Maintenance Team Detail
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                <Tab label="Offers History" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
            </div>
            <div className="gap_p">
              <div className="w_33">
                <h6>Name</h6>
                <p>{teamDetail?.fullName}</p>
              </div>
              <div className="w_33">
                <h6>Email Id</h6>
                <p>{teamDetail?.email}</p>
              </div>
              <div className="w_33">
                <h6>Phone Number</h6>
                <p>
                  {teamDetail?.countryCode}
                  {teamDetail?.phone}
                </p>
              </div>
            </div>
          </div>

          <div className="cards view_page">
            <div className="section_title">
              <h2>Profession/Skills</h2>
            </div>
            <div className="gap_p">
              <div className="w_33">
                <h6>Profession</h6>
                <p>
                  {teamDetail?.professionId
                    ?.map((item: any) => item?.categoryName)
                    .join(", ")}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="cards view_page">
            <div className="section_title">
              <h2>Bank Details</h2>
            </div>
            <div className="gap_p">
              <div className="w_33">
                <h6>Bank Name</h6>
                <p>Bank</p>
              </div>
              <div className="w_33">
                <h6>Account Holder’s Name</h6>
                <p>Name</p>
              </div>
              <div className="w_33">
                <h6>Account Number</h6>
                <p>0000 0000 0000</p>
              </div>
              <div className="w_33">
                <h6>IFSC Code</h6>
                <p>987654</p>
              </div>
              <div className="w_33">
                <h6>Branch Name</h6>
                <p>Branch</p>
              </div>
            </div>
          </div> */}

          <div className="cards view_page">
            <div className="section_title">
              <h2>Proof of experience</h2>
            </div>
            <div className="docFlex">
              {teamDetail?.professionalDocs?.length
                ? teamDetail?.professionalDocs.map((item, index) =>
                    item.endsWith(".pdf") ? null : (
                      <div key={index} className="childDiv">
                        <div className="upload_image no_radius v2">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={item}
                                alt="photo"
                              />
                            </figure>
                          </div>
                        </div>
                      </div>
                    )
                  )
                : null}
            </div>
            <div className="abc">
              {teamDetail?.professionalDocs?.length
                ? teamDetail.professionalDocs.map((item, index) =>
                    item.endsWith(".pdf") ? (
                      <div
                        key={index}
                        className="childDiv w_100"
                        style={{ width: "50%" }}
                      >
                        <div className="docView docview1">
                          <a
                            onClick={() => window.open(item)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <figure>
                              <img
                                src="/static/images/pdf.png"
                                alt="PDF Icon"
                              />
                            </figure>
                            <p style={{ cursor: "pointer" }}>View</p>
                          </a>
                        </div>
                      </div>
                    ) : null
                  )
                : null}
            </div>
          </div>

          <CompanyDocumentation
            userId={id || ""}
            setValueTabs={setValueTabs2}
            view={true}
            setOpenDocView={setOpenDocView}
            setDocViewImage={setDocViewImage}
          />

          {teamDetail?.status === USER_STATUS.PENDING ? (
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setType("approve");
                  setOpen(true);
                }}
              >
                Approve
              </Button>
              <Button
                className="btn btn_danger"
                onClick={() => {
                  setType("reject");
                  setReject(true);
                }}
              >
                Reject
              </Button>
            </div>
          ) : teamDetail?.status === USER_STATUS.REJECTED ? (
            <div className="rejectionDiv">
              <h3>Rejection Reason</h3>
              <p>{teamDetail?.rejectReason || ""}</p>
            </div>
          ) : null}
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    placeholder="Search..."
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
            </div>

            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Pending" {...a11yProps(0)} />
                <Tab label="Accepted" {...a11yProps(1)} />
                <Tab label="Approved" {...a11yProps(1)} />
                <Tab label="Scheduled" {...a11yProps(2)} />
                <Tab label="In Progress" {...a11yProps(3)} />
                <Tab label="Completed" {...a11yProps(4)} />
                <Tab label="Rejected" {...a11yProps(5)} />
              </Tabs>
              <CustomTabPanel value={valueTabs} index={0}>
                <OffersPendingList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  handleStatusUpdate={handleStatusUpdate}
                  setRejectionRsn={setRejectionRsn}
                  rejectionRsn={rejectionRsn}
                  setCommission={setCommission}
                  commission={commission}
                  setPdfFile={setPdfFile}
                  pdfFile={pdfFile}
                  setSelectedId={setSelectedId}
                  selectedPrice={selectedPrice}
                  setSelectedPrice={setSelectedPrice}
                  setSelectedQuatation={setSelectedQuatation}
                  selectedQuatation={selectedQuatation}
                  setOpen1={setOpen1}
                  setOpen={setOpen}
                  open={open}
                  open1={open1}
                  setDocOpen={setDocOpen}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={1}>
                <OffersAcceptedList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  setDocOpen={setDocOpen}
                  setSelectedQuatation={setSelectedQuatation}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={2}>
                <OffersApprovedList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  setDocOpen={setDocOpen}
                  setSelectedQuatation={setSelectedQuatation}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={3}>
                <OffersScheduledList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  setDocOpen={setDocOpen}
                  setSelectedQuatation={setSelectedQuatation}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={4}>
                <OffersInprogressList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  setDocOpen={setDocOpen}
                  setSelectedQuatation={setSelectedQuatation}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={5}>
                <OffersCompletedList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  setDocOpen={setDocOpen}
                  setSelectedQuatation={setSelectedQuatation}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={6}>
                <OffersRejectedList
                  count={count}
                  rows={rows}
                  handlePageChange={handlePageChange}
                  setPage={setPage}
                  loading={loading}
                  page={page}
                  setDocOpen={setDocOpen}
                  setSelectedQuatation={setSelectedQuatation}
                />
              </CustomTabPanel>
            </Box>
          </div>
        </CustomTabPanel>
        <TeamDocumentModal
          quatation={selectedQuatation || ""}
          open={docOpen}
          onClose={() => setDocOpen(!docOpen)}
          setOpen={setDocOpen}
        />
      </MainContainer>

      <ConfirmationModal
        text={`Are you sure to ${
          type === "approve" ? "approve" : "reject"
        } this team`}
        openModal={open}
        setOpenModal={setOpen}
        handleSubmit={() =>
          handleChangeStatus(
            type === "approve" ? USER_STATUS.APPROVED : USER_STATUS.REJECTED
          )
        }
      />
      <RejectedReasonDetailModal
        open={reject}
        onClose={() => setReject(false)}
        setOpen={setReject}
        setSelectedReasonType={setSelectedReasonType}
        selectedReasonType={selectedReasonType}
        rejectionRsn={rejectionRsn}
        handleSubmit={() =>
          handleChangeStatus(
            type === "reject" ? USER_STATUS.REJECTED : USER_STATUS.APPROVED
          )
        }
        setRejectionRsn={setRejectionRsn}
      />
      <ViewDocModal
        open={openDocView}
        onClose={() => setOpenDocView(false)}
        imageUrl={docViewImage || ""}
      />
      {/* <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      /> */}
    </>
  );
};

export default MaintenanceTeamDetail;
